import React from 'react'

import { Container } from './styles'

const ContentBetweenLines: React.FC = ({ children }) => {

    return (
        <Container>
            {children}
        </Container>
    )
}

export default ContentBetweenLines